import {Component} from '@angular/core';

@Component({
  selector: 'la-spacer',
  template: `
    <div class="la-spacer"></div>
  `,
})
export class LaSpacerComponent {
}
